import { v4 as uuidv4 } from "uuid";

export default [
    {
        "id": uuidv4(),
        "title": "Meeting with Ms. Bonnie from Themesberg LLC",
        "time": "10:00 AM",
        "statusKey": "inProgress",
        "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue."
    },
    {
        "id": uuidv4(),
        "title": "Upgrate to Volt Pro",
        "time": "10:00 AM",
        "statusKey": "done",
        "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue."
    },
    {
        "id": uuidv4(),
        "title": "Meeting with Ms. Bonnie from Themesberg LLC",
        "time": "10:00 AM",
        "statusKey": "inProgress",
        "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue."
    },
    {
        "id": uuidv4(),
        "title": "Meeting with Ms. Bonnie from Themesberg LLC",
        "time": "10:00 AM",
        "statusKey": "inProgress",
        "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue."
    },
    {
        "id": uuidv4(),
        "title": "Meeting with Ms. Bonnie from Themesberg LLC",
        "time": "10:00 AM",
        "statusKey": "waiting",
        "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue."
    },
    {
        "id": uuidv4(),
        "title": "Meeting with Ms. Bonnie from Themesberg LLC",
        "time": "10:00 AM",
        "statusKey": "waiting",
        "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue."
    },
    {
        "id": uuidv4(),
        "title": "Meeting with Ms. Bonnie from Themesberg LLC",
        "time": "10:00 AM",
        "statusKey": "done",
        "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pulvinar feugiat consequat. Duis lacus nibh, sagittis id varius vel, aliquet non augue."
    }
];